/**
 * Adiciona ou remove os produtos bônus da barra de prêmios.
 * O carrinho da Elaz não expõe o evento do tema Horizon, então a sincronização
 * observa as gravações em /cart/add, /cart/change e /cart/update e depois
 * pede ao drawer para redesenhar.
 */
(function () {
  if (window.__elazPrizeBonusInstalled) return;
  window.__elazPrizeBonusInstalled = true;

  var PROPERTY = '_elaz_prize';
  var syncing = false;
  var timer = null;

  function configNode() {
    return document.querySelector('script[data-cart-prize-bonus-config]');
  }

  function readConfig() {
    var node = configNode();
    if (!node) return null;
    try {
      var data = JSON.parse(node.textContent || '{}');
      if (!data.thresholds || !data.variantIds) return null;
      return data;
    } catch (error) {
      return null;
    }
  }

  function thresholdFor(value, mode) {
    var number = Number(value);
    if (mode === 'total') return number * 100;
    return number;
  }

  function refreshCartSurfaces() {
    ['cart-drawer', 'cart-page'].forEach(function (name) {
      document.querySelectorAll(name).forEach(function (element) {
        if (typeof element.update === 'function') element.update();
      });
    });
  }

  function cartUrl(path) {
    var routes = window.routes || {};
    var root = routes.root_url || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  async function syncBonus() {
    if (window.__elazGiftVariantChanging) return;
    var config = readConfig();
    if (!config || syncing) return;
    syncing = true;

    try {
      var cartResponse = await fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) return;
      var cart = await cartResponse.json();
      var cartItems = cart.items || [];
      var prizeLines = [];
      var prizeCount = 0;
      var prizeTotal = 0;
      cartItems.forEach(function (item) {
        var props = item.properties || {};
        if (!props[PROPERTY] && !props['_' + PROPERTY]) return;
        prizeLines.push(item);
        prizeCount += Number(item.quantity) || 0;
        prizeTotal += Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      });

      var mode = config.mode === 'total' ? 'total' : 'quantity';
      var current = mode === 'quantity'
        ? Math.max(0, (Number(cart.item_count) || 0) - prizeCount)
        : Math.max(0, (Number(cart.total_price) || 0) - prizeTotal);
      var configured = {};
      var shouldHave = {};

      config.variantIds.forEach(function (variantId, index) {
        var id = Number(variantId);
        if (!id) return;
        var productId = config.productIds ? Number(config.productIds[index]) : 0;
        var key = productId ? 'p' + productId : 'v' + id;
        configured[key] = id;
        if (current < thresholdFor(config.thresholds[index], mode)) return;
        shouldHave[key] = id;
      });

      var choice = window.__elazGiftChoice || {};
      var choiceVariant = String(choice.variantId || '').replace(/\D/g, '');
      var choiceSource = String(choice.sourceProductId || '').replace(/\D/g, '');

      function configuredSlot(item) {
        var props = item.properties || {};
        var sourceId = String(props._elaz_prize_source || '').replace(/\D/g, '');
        var ownId = item.product_id ? String(item.product_id) : '';
        if (sourceId && configured['p' + sourceId]) return 'p' + sourceId;
        if (ownId && configured['p' + ownId]) return 'p' + ownId;
        if (choiceVariant && String(item.variant_id) === choiceVariant && choiceSource && configured['p' + choiceSource]) {
          return 'p' + choiceSource;
        }
        return '';
      }

      var groups = {};
      var loose = [];
      prizeLines.forEach(function (item) {
        var slot = configuredSlot(item);
        if (!slot) {
          loose.push(item);
          return;
        }
        groups[slot] = groups[slot] || [];
        groups[slot].push(item);
      });

      var configuredKeys = Object.keys(configured);
      if (configuredKeys.length === 1 && loose.length) {
        var onlySlot = configuredKeys[0];
        groups[onlySlot] = (groups[onlySlot] || []).concat(loose);
        loose = [];
      }

      var present = {};
      var removals = [];
      var lineFixes = [];
      loose.forEach(function (item) {
        removals.push(item.key);
      });

      Object.keys(groups).forEach(function (slot) {
        var lines = groups[slot];
        if (!shouldHave[slot]) {
          lines.forEach(function (item) {
            removals.push(item.key);
          });
          return;
        }

        var keep = lines[0];
        lines.forEach(function (item) {
          var chosen = String((item.properties || {})._elaz_variant_chosen || '') === '1';
          var keepChosen = String((keep.properties || {})._elaz_variant_chosen || '') === '1';
          var isChoice = choiceVariant && String(item.variant_id) === choiceVariant;
          var keepIsChoice = choiceVariant && String(keep.variant_id) === choiceVariant;
          if (isChoice) keep = item;
          else if (!keepIsChoice && chosen && !keepChosen) keep = item;
          else if (!keepIsChoice && chosen && keepChosen) keep = item;
        });

        lines.forEach(function (item) {
          if (item.key !== keep.key) removals.push(item.key);
        });
        present[slot] = true;

        var props = {};
        var currentProps = keep.properties || {};
        Object.keys(currentProps).forEach(function (name) {
          props[name] = currentProps[name];
        });
        var configuredId = slot.charAt(0) === 'p' ? slot.slice(1) : '';
        var needsSource = configuredId && String(props._elaz_prize_source || '') !== configuredId;
        var needsQty = Number(keep.quantity) !== 1;
        if (!needsSource && !needsQty) return;
        if (needsSource) props._elaz_prize_source = configuredId;
        lineFixes.push({
          key: keep.key,
          quantity: 1,
          properties: needsSource ? props : null
        });
      });

      var additions = Object.keys(shouldHave).filter(function (key) {
        return !present[key];
      }).map(function (key) {
        return shouldHave[key];
      });

      if (!removals.length && !additions.length && !lineFixes.length) return;

      await Promise.all(removals.map(function (key) {
        var body = new FormData();
        body.append('id', key);
        body.append('quantity', '0');
        return fetch(cartUrl('cart/change.js'), {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        });
      }));

      if (lineFixes.length) {
        await Promise.all(lineFixes.map(function (fix) {
          var payload = { id: fix.key, quantity: fix.quantity };
          if (fix.properties) payload.properties = fix.properties;
          return fetch(cartUrl('cart/change.js'), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });
        }));
      }

      if (additions.length) {
        await fetch(cartUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: additions.map(function (id) {
              var properties = {};
              properties[PROPERTY] = '1';
              return { id: Number(id), quantity: 1, properties: properties };
            })
          })
        });
      }

      refreshCartSurfaces();
    } catch (error) {
      /* A próxima alteração do carrinho tenta de novo. */
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      syncBonus();
    }, 300);
  }

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var response = nativeFetch(input, init);
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (error) {
      url = '';
    }

    if (!syncing && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      response.then(function (result) {
        if (result && result.ok) scheduleSync();
      }).catch(function () {});
    }

    return response;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  function start() {
    watchDrawer();
    scheduleSync();
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__elazPrizeWatch) return;
    drawer.__elazPrizeWatch = true;
    var observer = new MutationObserver(function () {
      if (drawer.classList.contains('is-opened')) scheduleSync();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (window.XMLHttpRequest) {
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__elazCartUrl = url || '';
      return originalOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      this.addEventListener('load', function () {
        var url = String(this.__elazCartUrl || '');
        if (!syncing && this.status >= 200 && this.status < 300 && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          scheduleSync();
        }
      });
      return originalSend.apply(this, arguments);
    };
  }
})();
